import { z } from 'zod';
import { CustomErrorParams, CustomErrorType, Validation } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export enum DetailsFieldName {
    Names = 'names',
    ShortNames = 'shortNames',
    Descriptions = 'descriptions',
    ExternalNames = 'externalNames',
    IsEnabled = 'isEnabled',
    IsDefault = 'isDefault',
    Ordering = 'ordering',
    Type = 'type',
    ServiceId = 'serviceId',
    RateGroupId = 'rateGroupId',
    BaseRateId = 'baseRateId',
    RateKey = 'rateKey',
    DefaultReservationPurpose = 'defaultReservationPurpose',
    PricingClassification = 'pricingClassification',
    AccountingCategoryId = 'accountingCategoryId',
    BusinessSegmentId = 'businessSegmentId',
    HidePriceFromGuest = 'hidePriceFromGuest',
    IsBonusPointsEligible = 'isBonusPointsEligible',
}

export const timePeriodSchema = z.object({
    dateRange: z.object({
        dateStart: Validation.Date.Iso,
        dateEnd: Validation.Date.Iso,
        timeStart: z.string().nullable(),
        timeEnd: z.string().nullable(),
    }),
    days: z.string().array().min(1),
    hours: z.string().array().min(1),
});

export const SeasonalAdjustmentFormSchema = z
    .object({
        adjustment: z
            .object({
                relative: z.number().optional(),
                absolute: z.number().optional(),
            })
            .superRefine((data, ctx) => {
                if (data.relative === undefined && data.absolute === undefined) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        path: ['relative'],
                        params: {
                            errorType: CustomErrorType.Other,
                            textKey: TextKey.SeasonalAdjustmentAdjustmentsEmptyValidationMessage,
                        } satisfies CustomErrorParams,
                    });

                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        path: ['absolute'],
                        params: {
                            errorType: CustomErrorType.Other,
                            textKey: TextKey.SeasonalAdjustmentAdjustmentsEmptyValidationMessage,
                        } satisfies CustomErrorParams,
                    });
                }
            }),
    })
    .merge(timePeriodSchema);

export type SeasonalAdjustmentFormValues = z.infer<typeof SeasonalAdjustmentFormSchema>;
